<mat-drawer-container hasBackdrop>
  <mat-drawer autoFocus="false"
    #drawer
    mode="over"
    position="end"
    (closed)="close()">
  </mat-drawer>
  <mat-drawer-content>
    <div class="pcs-container">
      <div class="pcs-header">
        @if (product) {
          <h3 class="pcs-title"
          >{{ product.name }}</h3>
        }
        </div>
        @if (!isProviderReadOnly()) {
        <div class="upload-container">
          <div class="upload-container-body">
            <p class="title">Upload MBR</p>
            <p>This document will be marked as default, and you can then modify that in the table below.</p>
            <app-upload-documents [isMulti]="false"
              (onFileRemove)="fileRemoved($event)"
              (uploadingEvent)="uploadingEvent($event)" />
            </div>
            <div class="text-end">
              <button (click)="onSubmit()"
                [disabled]="!canUpload"
                mat-flat-button
                color="primary"
                type="button"
                class="btn btn-primary">
                Upload MBR Document
              </button>
            </div>
          </div>
        }
          <div class="pro-card column">
            <app-ag-grid-wrapper
              [data]="rowData"
              [columns]="columnDefs"
              (ready)="onGridReady($event)"
              />
              <mat-paginator
                #paginator
                [selectConfig]="{ panelClass: 'mat-paginator-select-options' }"
                [length]="totalCount"
                [pageIndex]="currentPage"
                [pageSize]="pageSize"
                [pageSizeOptions]="pageSettings.pageSizeOptions"
                (page)="handlePageEvent($event)"
                aria-label="Select page"
                >
              </mat-paginator>
            </div>
          </div>

        </mat-drawer-content>
      </mat-drawer-container>
